import { render, staticRenderFns } from "./EditSupervisor.vue?vue&type=template&id=00182156&scoped=true&"
import script from "./EditSupervisor.vue?vue&type=script&lang=js&"
export * from "./EditSupervisor.vue?vue&type=script&lang=js&"
import style0 from "./EditSupervisor.vue?vue&type=style&index=0&id=00182156&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00182156",
  null
  
)

export default component.exports